module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/school1-794f35e3e3d4dd7a76863f5bbea7c756.svg";